module.exports = __webpack_public_path__ + "static/media/44.7a1317a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/44.jpg
// module id = 413
// module chunks = 0